import {isSet,isEmpty,source} from './utils/common'
export function prepaymentCalc(){
	if(validatePrepaymentForm()){
		let prepayment_loan_amount = document.getElementById('prepayment_loan_amount').value;
		prepayment_loan_amount = parseInt(prepayment_loan_amount);
		let prepayment_amount = document.getElementById('prepayment_amount').value;
		prepayment_amount = parseInt(prepayment_amount);
		if(prepayment_amount >= prepayment_loan_amount){
			document.getElementById('error_message').innerHTML = 'Prepayment amount should be less than loan amount.';
            document.getElementById('hc_error_popup').click();
            return false;
		}
		document.getElementById('spinner').classList.remove('hidden');
		//ajax
		$.ajax({
            url: "/homes/re2/homeloanPrepaymentCalc?aj=1",
            type: "POST",
            data: {'homeloanPrepaymentCalc' : JSON.stringify(homeloancalc.prepaymentCalc)},
            success: function (data) {
                if(!isEmpty(data)){
                	document.getElementById('spinner').classList.add('hidden');
                	document.getElementById('hl_prepayment_response').classList.remove('opacity_otp');
                	let emiResp = data['homeLoanPrepaymentRevisedEmiCalculatorResponse'];
                	document.getElementById('prepayment_revised_emi').innerHTML = '&#8377; ' + emiResp['revisedEmi'];
                    document.getElementById('prepayment_savings_emi').innerHTML = '&#8377; ' + emiResp['savingsInEmi'];
                    document.getElementById('prepayment_interest_saved').innerHTML = '&#8377; ' + emiResp['totalInterestSaved'];

                    let tenureResp = data['homeLoanPrepaymentRevisedTenureCalculatorResponse'];
                	document.getElementById('prepayment_revised_months').innerHTML = tenureResp['revisedTenureInMonths'] + ' Months';
                    document.getElementById('prepayment_reduction_tenure').innerHTML =  tenureResp['reductionInTenure'] + ' Months';
                }else{
                	document.getElementById('spinner').classList.add('hidden');
                    document.getElementById('error_message').innerHTML = 'Request not found. Please try again by changing values.';
                    document.getElementById('hc_error_popup').click();
                    return false;
                }
            } 
        });
	}else {
		return false;
	}
}

export function resetPrepaymentForm(){
	document.getElementById('prepayment_loan_amount').value = '';
	document.getElementById('prepayment_loan_tenure_year').value = '';
	document.getElementById('prepayment_loan_tenure_month').value = '';
	document.getElementById('prepayment_rate_of_interest').value = '';
	document.getElementById('prepayment_loan_amount_price').innerHTML = '';
	document.getElementById('prepayment_rate_of_interest_price').innerHTML = '';
	document.getElementById('prepayment_installments_paid').value = '';
	document.getElementById('prepayment_installments_paid_price').innerHTML = '';
	document.getElementById('prepayment_amount').value = '';
	document.getElementById('prepayment_amount_price').innerHTML = '';
	document.getElementById('hl_prepayment_response').classList.add('opacity_otp');
	document.getElementById('prepayment_revised_emi').innerHTML = '&#8377; 00.00';
	document.getElementById('prepayment_revised_months').innerHTML = ' Months';
    document.getElementById('prepayment_reduction_tenure').innerHTML = ' Months';
    document.getElementById('prepayment_savings_emi').innerHTML = '&#8377; 00.00';
    document.getElementById('prepayment_interest_saved').innerHTML = '&#8377; 00.00';

}

function validatePrepaymentForm(){
	let isEmiFormValid = false;
	//Prepayment loan amount check..
	if(isPaymentLoanAmountValid()) {
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Prepayment loan tenure year and month check
	if(isPrePaymentLoanTenureValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Prepayment rate of interest check
	if(isPaymentRateOfInterestValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Prepayment payment amount check
	if(isPrePaymentAmountValid()) {
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Prepayment installments check
	if(isPrePaymentInstallmentsValid()) {
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	return isEmiFormValid;
}

function isPaymentLoanAmountValid() {
	let prepayment_loan_amount = document.getElementById('prepayment_loan_amount').value;
	let regex = /^[0-9, ]+$/i;
	if(prepayment_loan_amount.match(regex) && prepayment_loan_amount !='') {
		HomeLoanCalculator.hideError('prepayment_loan_amount_error');
		homeloancalc.prepaymentCalc.prepayment_loan_amount = prepayment_loan_amount.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid loan amount";
		HomeLoanCalculator.showError('prepayment_loan_amount_error', msg);
		return false;
	}
}

function isPrePaymentAmountValid() {
	let prepayment_amount = document.getElementById('prepayment_amount').value;
	let regex = /^[0-9, ]+$/i;
	if(prepayment_amount.match(regex) && prepayment_amount !='') {
		HomeLoanCalculator.hideError('prepayment_amount_error');
		homeloancalc.prepaymentCalc.prepayment_amount = prepayment_amount.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid prepayment amount";
		HomeLoanCalculator.showError('prepayment_amount_error', msg);
		return false;
	}
}

export function isPrePaymentLoanTenureValid() {
	let tenure_year = document.getElementById('prepayment_loan_tenure_year').value;
	let tenure_month = document.getElementById('prepayment_loan_tenure_month').value;
	if(tenure_year == '' && tenure_month == ''){
		let msg = "Enter valid loan tenure years or months";
		HomeLoanCalculator.showError('prepayment_loan_tenure_error', msg);
		return false;
	}else if(tenure_year != '' && tenure_month == ''){
		isEmiLoanTenureYearValid(tenure_year);
	}else if(tenure_month != '' && tenure_year == ''){
		isEmiLoanTenureMonthValid(tenure_month);
	}else {
		let YearTenure = isEmiLoanTenureYearValid(tenure_year);
		let MonthTenure = isEmiLoanTenureMonthValid(tenure_month);
		if(YearTenure && MonthTenure){
			HomeLoanCalculator.hideError('prepayment_loan_tenure_error');
			return true;
		}else if(!YearTenure){
			let msg = "Enter valid loan tenure years";
			HomeLoanCalculator.showError('prepayment_loan_tenure_error', msg);
		}else if(!MonthTenure){
			let msg = "Enter valid loan tenure months";
			HomeLoanCalculator.showError('prepayment_loan_tenure_error', msg);
		}
	}
		
}

function isEmiLoanTenureYearValid(tenure_year) {
	let regex = /^[0-9, ]+$/i;
	if(tenure_year.match(regex) && tenure_year !='') {
		HomeLoanCalculator.hideError('prepayment_loan_tenure_error');
		homeloancalc.prepaymentCalc.tenure_year = tenure_year.replace(/,/g, '');
		return true;
	} else {
		document.getElementById('prepayment_loan_tenure_year').value = '';
		let msg = "Enter valid loan tenure years";
		HomeLoanCalculator.showError('prepayment_loan_tenure_error', msg);
		return false;
	}
}

function isEmiLoanTenureMonthValid(tenure_month) {
	let regex = /^[0-9 ]+$/i;
	if(tenure_month !='' && tenure_month.match(regex) && tenure_month >= 0 && tenure_month < 12) {
		HomeLoanCalculator.hideError('prepayment_loan_tenure_error');
		homeloancalc.prepaymentCalc.tenure_month = tenure_month;
		return true;
	} else {
		document.getElementById('prepayment_loan_tenure_month').value = '';
		let msg = "Enter valid loan tenure months";
		HomeLoanCalculator.showError('prepayment_loan_tenure_error', msg);
		return false;
	}
}

function isPrePaymentInstallmentsValid() {
	let prepayment_installments_paid = document.getElementById('prepayment_installments_paid').value;
	prepayment_installments_paid = prepayment_installments_paid.replace(/,/g, '');
	let regex = /^[0-9]+$/i;
	if(prepayment_installments_paid.match(regex) && prepayment_installments_paid !='') {
		HomeLoanCalculator.hideError('prepayment_installments_paid_error');
		homeloancalc.prepaymentCalc.prepayment_installments_paid = prepayment_installments_paid.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid installments paid";
		HomeLoanCalculator.showError('prepayment_installments_paid_error', msg);
		return false;
	}
}

function isPaymentRateOfInterestValid() {
	let prepayment_rate_of_interest = document.getElementById('prepayment_rate_of_interest').value;
	let regex = /^[0-9. ]+$/i;
	if(prepayment_rate_of_interest.match(regex) && prepayment_rate_of_interest !='') {
		HomeLoanCalculator.hideError('prepayment_rate_of_interest_error');
		homeloancalc.prepaymentCalc.prepayment_rate_of_interest = prepayment_rate_of_interest.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid rate of interest";
		HomeLoanCalculator.showError('prepayment_rate_of_interest_error', msg);
		return false;
	}
}


